export default Object.freeze({
	AUTH_TOKEN_HEADER: 'auth-token',
	CAREER_PYTHON_SERVICE_COURSE_ID_HEADER: 'course_id',
	COURSE_ID_HEADER: 'courseId',
	SESSION_ID_HEADER: 'sessionId',
});
